module.exports = __webpack_public_path__ + "static/img/snow1.8cfeac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snow1.jpg
// module id = LjP4
// module chunks = 0